import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=521f8294&scoped=true"
var script = {}
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=521f8294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f8294",
  null
  
)

export default component.exports